import { useCallback } from 'react';
import { AppModal } from '@lib/common';
export var useDeleteConfirmation = function useDeleteConfirmation(_ref) {
  var itemType = _ref.itemType,
      itemName = _ref.itemName;
  var confirmDelete = useCallback(function (onConfirm, onCancel) {
    var getDeleteMessage = function getDeleteMessage() {
      switch (itemType) {
        case 'file':
          return "Are you sure you want to delete this uploaded file?".concat(itemName ? " \"".concat(itemName, "\"") : '');

        case 'url':
          return "Are you sure you want to delete this URL?".concat(itemName ? " \"".concat(itemName, "\"") : '');

        case 'library':
          return "Are you sure you want to delete this file from library?".concat(itemName ? " \"".concat(itemName, "\"") : '');

        default:
          return 'Are you sure you want to delete this item?';
      }
    };

    AppModal.confirm({
      title: 'Confirm Delete',
      content: getDeleteMessage(),
      okText: 'Delete',
      cancelText: 'Cancel',
      onOk: onConfirm,
      onCancel: onCancel,
      className: 'delete-confirmation-modal'
    });
  }, [itemType, itemName]);
  return {
    confirmDelete: confirmDelete
  };
};